import actions from './actions/de-DE';
import appointmentRequest from './appointment-request/de-DE';
import appointmentTasks from './appointment-tasks/de-DE';
import appointment from './appointment/de-DE';
import confirmAction from './confirm-action/de-DE';
import dataSecurity from './data-security/de-DE';
import enums from './enums/de-DE';
import facilitySelection from './facility-selection/de-DE';
import footer from './footer/de-DE';
import form from './form/de-DE';
import home from './home/de-DE';
import imprint from './imprint/de-DE';
import placeholders from './placeholders/de-DE';
import passwordReset from './reset-password/de-DE';
import signup from './signup/de-DE';
import slotSelection from './slot-selection/de-DE';
import user from './user/de-DE';

export default {
  'locale.de-DE': 'Deutsch',
  'locale.en-US': 'English',

  ...form,
  ...actions,
  ...dataSecurity,
  ...home,
  ...placeholders,
  ...slotSelection,
  ...signup,
  ...footer,
  ...enums,
  ...appointment,
  ...appointmentRequest,
  ...facilitySelection,
  ...imprint,
  ...user,
  ...confirmAction,
  ...passwordReset,
  ...appointmentTasks,

  // MISC
  'not-found.message': 'Es tut uns leid. Die angeforderte Seite existiert nicht.',
  'not-found.back-home': 'Zur Startseite',

  phone: 'Rufnummer',
  fax: "Fax",
  address: 'Adresse',

  current: 'Aktuell',

  'e-mail': 'E-Mail',

  'error.title': 'Seite in Arbeit',
  'error.message':
    'Bitte entschuldigen Sie die Unannehmlichkeiten. Wir führen aktuell Wartungsarbeiten an dieser Seite durch. Die Seite sollte Ihnen bald wieder zur Verfügung stehen.',

  documents: 'Dokumente',
  user: 'Benutzer',
  account: 'Konto',
  empty: 'Keine Daten vorhanden',
  email: 'E-Mail',
  'email.required': 'Bitte geben Sie Ihre E-Mail Adresse ein',
  password: 'Passwort',
  'password.required': 'Bitte geben Sie Ihr Passwort ein',

  upcoming: 'Anstehend',
  past: 'Vergangen',
  requested: 'Anfragen',
  archived: 'Archiviert',

  morning: 'Morgens',
  noon: 'Mittags',
  afternoon: 'Nachmittags',
  evening: 'Abends',

  register: 'Konto registrieren',
};
